export default "__VITE_ASSET__CtGDdZlY__"